import { ChannelConfig } from '../config';

export const GET_UPCOMING_EVENTS = 'GET_UPCOMING_EVENTS';
export const GET_UPCOMING_EVENTS_SUCCESS = 'GET_UPCOMING_EVENTS_SUCCESS';
export const GET_UPCOMING_EVENTS_ERROR = 'GET_UPCOMING_EVENTS_ERROR';

export interface UpcomingEventsRequest {
    salesChannel: ChannelConfig;
}

export interface EventSingle {
    avfms_sport: string;
    away_team_logo_url: string;
    background_image_url: string;
    category: string;
    created_at: string;
    event_id: string;
    id: number;
    is_default_offer_enabled: boolean;
    league: string;
    logo_url: string;
    marketplace_cutoff_at: string;
    price_rules: string;
    rewards: string;
    sales_channel_id: number;
    seat_upgrade_background_image_url: string;
    security_phrase: string;
    status: number;
    time: string;
    timezone: string;
    title: string;
    venue: string;
}

export interface UpcomingEventsError {
    body?: {
        message?: string;
        status?: string;
    };
    message?: string;
    name?: string;
    status?: number;
}

export interface UpcomingEventsState {
    data: Array<EventSingle> | null;
    loading: boolean;
    error: UpcomingEventsError | null;
}

export interface GetUpcomingEventsAction {
    type: typeof GET_UPCOMING_EVENTS;
}

export interface GetUpcomingEventsSuccessAction {
    type: typeof GET_UPCOMING_EVENTS_SUCCESS;
    payload: Array<EventSingle>;
}

export interface GetUpcomingEventsErrorAction {
    type: typeof GET_UPCOMING_EVENTS_ERROR;
    payload: UpcomingEventsError;
}

export type UpcomingEventsAction =
    | GetUpcomingEventsAction
    | GetUpcomingEventsSuccessAction
    | GetUpcomingEventsErrorAction;
